// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2162": "50116afa","5229": "435c2157","5336": "5083bc52",}[chunkId] + ".css"
}